export var combineChecks = function (checks) { return function (path) {
    return function (action, state$, deps) {
        var allChecksPass = checks.every(function (check) {
            var result = check(path)(action, state$, deps);
            return result != undefined;
        });
        return allChecksPass ? path : undefined;
    };
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/guards/combineChecks.ts
// module id = 107
// module chunks = 3